<!-- <div *ngIf="!loginDisplay">
    <p class="welcome" >SCS Lupin Azure POC</p>

    <p>Please sign-in to see your profile information.</p>
</div>

<div class="text"  *ngIf="loginDisplay">
    <p>Login successful!</p>
</div> -->

<div *ngIf="showTiles" class="tiles-container">
  <ng-container *ngFor="let app of applicationTiles">
    <mat-card *ngIf="app?.showTile" class="app-tile" [style.background-color]="app.bgColor" [style.color]="app.foregroundColor">
      <div class="title-container" (click)="onTileClick(app)">
        <h1 class="title"> {{ app?.applicationName }} </h1>
      </div>
      <span class="more-info" (click)="onMoreInfoClick(app?.appDescription)">
        click here to know more...
      </span>
    </mat-card>
  </ng-container>
</div>

<!-- <div> -->
  <!-- <div *ngIf="displayMsg">
    <h3> Welcome to SCS Lupin Azure</h3>
  </div> -->
  <!-- <div *ngIf="displayDisclaimer" class="disclaimer-content">
    <h1 class="title">DISCLAIMER OF LUPIN SUPPLIER PORTAL</h1>
    <p>We are pleased to provide this Supplier Portal for your benefit, subject to conditions applicable to all suppliers and the entity or organization represented 
      (collectively referred to as “Supplier”). Please note that the Supplier Portal is a web-based system hosted by Lupin Limited. All personal information collected 
      through this Supplier Portal will be treated confidential and will not be passed on to third parties, and will only be used for purposes consistent with the purpose 
      of the Supplier Portal or on the Supplier Portal itself.
    </p>
    <p>BY USING THE SUPPLIER PORTAL, YOU CONSENT TO BE BOUND BY THIS DISCLAIMER.</p>
    <p>Unauthorized use of the Supplier Portal, including but not limited to unauthorized entry or attempted entry, misuse of any information available in or through the Supplier Portal, or illegal conduct, is strictly prohibited as governed by Cybersecurity laws in the respective countries. By continuing usage of this Supplier Portal, you agree that You are the only one authorized to use the Supplier Portal for your business use and that You shall not duplicate, download, publish, modify, canvass or otherwise distribute Supplier Portal material other than to review and manage your supplier account information. On registering to the Supplier Portal, You will be issued an account that will have an assigned user name and password that should not be shared with others, any unauthorised access or use by third parties is strictly prohibited. You are solely responsible for all activities that occur under your password or account or as a result of your access 
      to the Supplier Portal.</p>
    <p>You agree to notify us immediately of any unauthorized use of your password or account.</p>
    <p>You are responsible for requesting your account's deactivation upon the termination of your supplier relation with Lupin. Lupin will not be responsible for any loss or damage arising from your failure to comply with this Disclaimer.</p>
    <div style=" display: flex; justify-content: center;" >
      <button mat-raised-button class="btn" (click)="onClickAgree()" color="accent">Agree</button>
    </div>
  </div> -->
  
  <ngx-spinner name="sp1" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#fff" template="<img src='assets/icons/lupin-icongif.gif' style='height: 70px !important;'/>"
    [fullScreen]="false">
  </ngx-spinner>
<!-- </div> -->
